import Comp from "./CommentItem";
export { default as CommentItemV2 } from "./CommentItemV2";
export default Comp;
